let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("96uOJ")).then(() => parcelRequire('kOOhP'));